<!--
 * @Author: Tahiti
 * @Date: 2025-12-03 18:29:40
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 22:30:04
 * @Description: 
 * @FilePath: /weryai-web/components/Pay/PendingOrder.vue
-->
<template>
    <div v-if="visible" class="fixed inset-0 z-[3000] flex items-center justify-center bg-black/70"
        @click.self="handleClose">
        <div class="relative min-h-[312px] flex flex-col bg-[#22242D] rounded-[20px] p-3 md:p-5 max-md:w-[90vw] min-w-[320px] md:min-w-[500px] max-w-[800px] mx-4 shadow-2xl max-h-[90vh] overflow-y-auto"
            @click.stop>
            <button @click="closePendingOrderForever"
                class="absolute top-4 right-3 md:right-5 w-6 h-6 flex items-center justify-center text-white hover:scale-105 hover:rotate-180 transition-all duration-300 z-10">
                <img src="@/assets/images/common/_close.webp" alt="close" class="w-[24px]" />
            </button>
            <h1 class="text-white text-center w-full text-[20px] mb-2 font-medium">
                <div class="w-4/5 mx-auto leading-[20px]">
                    {{ t('order_modal.pending_order_title') }}
                </div>
            </h1>
            <p v-if="countdown > 0"
                class="text-text-adad w-full flex flex-wrap items-center justify-center text-center text-[13px] mb-[30px]"
                v-html="t('order_modal.pending_order_subtitle', {
                    time_1: `${formatTime(minutes)}`,
                    time_2: `${formatTime(seconds)}`,
                })
                    "></p>
            <div></div>
            <div v-if="loading" class="flex flex-col items-center justify-center py-8 mt-[50px]">
                <l-dot-spinner v-if="isClient" size="60" speed="0.9"
                    color="var(--el-menu-active-color)"></l-dot-spinner>
            </div>
            <div v-else class="flex flex-col gap-[15px] bg-[#333643] rounded-[10px] p-[10px]">
                <template v-if="recentCreatedOrder?.goods">
                    <div class="flex items-center justify-between gap-[10px]">
                        <span class="text-text-adad text-base">
                            {{ t('order_modal.product') }}
                        </span>
                        <span class="text-white text-base font-medium">
                            {{ recentCreatedOrder?.goods?.name }}
                        </span>
                    </div>
                    <div v-if="recentCreatedOrder?.goods?.origin_price_show"
                        class="flex items-center justify-between gap-[10px]">
                        <span class="text-text-adad text-base">
                            {{ t('order_modal.original_price') }}
                        </span>
                        <span class="flex items-center text-white text-base font-medium line-through">
                            <span v-if="
                                recentCreatedOrder?.goods?.period_type ===
                                'YEARLY'
                            ">
                                {{
                                    oneMonthPrice(
                                        recentCreatedOrder?.goods?.origin_price
                                    )
                                }}
                            </span>
                            <span v-else class="text-white text-base font-medium line-through">
                                {{
                                    recentCreatedOrder?.goods?.origin_price_show
                                }}
                            </span>
                            <span class="text-sm">
                                {{ t('pricing.month') }}
                            </span>
                        </span>
                    </div>
                    <div class="flex items-center justify-between gap-[10px]">
                        <span class="text-text-adad text-base">
                            {{ t('order_modal.now_price') }}
                        </span>

                        <span v-if="recentCreatedOrder?.goods?.subscription_type" class="flex items-center">
                            <span v-if="
                                recentCreatedOrder?.goods?.period_type ===
                                'YEARLY'
                            ">
                                {{
                                    oneMonthPrice(
                                        recentCreatedOrder?.goods?.discounted_price || recentCreatedOrder?.goods?.price
                                    )
                                }}
                            </span>
                            <span v-else class="text-white text-base font-medium flex items-center">
                                {{ recentCreatedOrder?.goods?.discounted_price_show ||
                                    recentCreatedOrder?.goods?.price_show }}
                            </span>
                            <span class="text-sm">
                                {{ t('pricing.month') }}
                            </span>
                        </span>
                        <span v-else class="text-white text-base font-medium">
                            {{ recentCreatedOrder?.goods?.discounted_price_show || recentCreatedOrder?.goods?.price_show
                            }}
                        </span>
                    </div>
                    <div v-if="recentCreatedOrder?.goods?.period_type"
                        class="flex items-center justify-between gap-[10px]">
                        <span class="text-text-adad text-base">
                            {{ t('order_modal.purchase_method') }}
                        </span>
                        <span
                            class="text-white text-base font-medium block min-h-[39px] text-center rounded-[10px] bg-white/5 p-[10px] min-w-[88px]">
                            {{ purchaseMethodText }}
                            <span v-if="discountText" class="percentage">
                                {{ discountText }}
                            </span>
                        </span>
                    </div>
                    <div class="w-full h-[1px] bg-white/10"></div>
                    <div v-if="recentCreatedOrder?.goods?.subscription_type"
                        class="flex items-center justify-end gap-5">
                        <span v-if="
                            recentCreatedOrder?.goods?.origin_price_show &&
                            recentCreatedOrder?.goods?.period_type ===
                            'YEARLY'
                        " class="line-through text-text-adad text-[13px] font-medium">
                            <span>{{
                                recentCreatedOrder?.goods?.origin_price_show
                                }}</span>
                            <span>{{ t('order_modal.year_price') }}</span>
                        </span>
                        <span class="text-white text-[20px] font-medium">
                            <span>{{
                                recentCreatedOrder?.goods?.discounted_price_show ||
                                recentCreatedOrder?.goods?.price_show
                                }}</span>
                            <span>{{
                                recentCreatedOrder?.goods?.period_type ===
                                    'YEARLY'
                                    ? t('order_modal.year_price')
                                    : t('pricing.month')
                            }}</span>
                        </span>
                    </div>
                    <div v-else class="flex items-center justify-end gap-5">
                        <span class="text-white text-[20px] font-medium">{{
                            recentCreatedOrder?.goods?.discounted_price_show || recentCreatedOrder?.goods?.price_show
                            }}</span>
                    </div>
                </template>

                <template v-else>
                    <div class="flex items-center justify-center py-8 min-h-[140px]">
                        <span class="text-white text-base font-medium">
                            <span>{{
                                t('order_modal.order_query_failed')
                                }}</span>
                            <button class="text-text-active underline text-[16px] font-medium"
                                @click="getRecentCreatedOrder">
                                {{ t('order_modal.order_query_failed_button') }}
                            </button>
                        </span>
                    </div>
                </template>
            </div>
            <div v-if="recentCreatedOrder?.goods" class="flex items-center justify-center gap-5 mt-[30px]">
                <!-- :class="[recentCreatedOrder?.coupon_code ? 'grid-cols-1' : 'grid-cols-2']" class="grid gap-5 mt-[30px]"> -->
                <!-- <button v-if="!recentCreatedOrder?.coupon_code"
                    class="h-[44px] rounded-[8px] text-[13px] flex gap-1 items-center justify-center bg-white text-black font-medium hover:bg-white/80 disabled:opacity-50 transition-all duration-300"
                    @click="payMoneyTypeFromPayPal" :disabled="loading">
                    <img src="https://static.weryai.com/growth/image/6c3a9383de3c74e3fce01f9be859d65e.webp" alt="paypal"
                        class="w-6 h-6" />
                    <span>{{ t('order_modal.paypal') }}</span>
                </button> -->

                <button :disabled="loading"
                    class="h-[44px] px-5 min-w-[200px] rounded-[8px] disabled:opacity-50 bg-create-btn text-black flex items-center justify-center text-base font-medium hover:bg-create-btn/70 transition-all duration-300"
                    @click="handleContinuePay">
                    {{ recentCreatedOrder?.coupon_code ? t('coupon_price.to_pay') : t('order_modal.continue_pay') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useI18n } from '~/composables/useI18n'
import { useAppStore } from '~/stores/app'
import {
    emitOpenAirwallexPayModal,
    emitOrderGoods,
    emitUpgradeOrder,
    emitter,
} from '~/utils/emitter'
import { useToolsHooks } from '~/utils/useHooks'
import { sendCreatedOrderApi } from '~/api/billing'
import { getRecentCreatedOrderApi } from '~/api/common'

const appStore = useAppStore()
const recentCreatedOrder = ref<any>(null)
const { t } = useI18n()
const visible = defineModel<boolean>('visible', { required: true })

const { yearDiscountEnums } = useToolsHooks()

// 倒计时相关
const countdown = ref(0) // 总毫秒数
let countdownTimer: NodeJS.Timeout | null = null
let startTime = 0 // 开始时间戳

// 格式化时间，确保两位数显示
const formatTime = (time: number): string => {
    return time.toString().padStart(2, '0')
}

// 计算分钟、秒、毫秒（百分之一秒，00-99）
const minutes = computed(() => Math.floor(countdown.value / 60000))
const seconds = computed(() => Math.floor((countdown.value % 60000) / 1000))
const milliseconds = computed(() => Math.floor((countdown.value % 1000) / 10))

// 购买方式文本
const purchaseMethodText = computed(() => {
    const periodType = recentCreatedOrder.value?.goods?.period_type
    return periodType === 'YEARLY'
        ? t('order_modal.year_pay')
        : t('order_modal.monthly_pay')
})

// 折扣标签文本
const discountText = computed(() => {
    const goods = recentCreatedOrder.value?.goods
    if (!goods) return ''

    const { period_type, subscription_type } = goods

    // CHAT_PLAN 类型使用 period_type 作为 key
    if (subscription_type === 'CHAT_PLAN') {
        return yearDiscountEnums[period_type] || ''
    }

    // 年付且非 CHAT_PLAN 使用 subscription_type 作为 key
    if (period_type === 'YEARLY') {
        return yearDiscountEnums[subscription_type] || ''
    }

    return ''
})

// 启动倒计时
const startCountdown = () => {
    if (countdownTimer) {
        clearInterval(countdownTimer)
    }

    if (recentCreatedOrder.value?.left_seconds) {
        // 将秒数转换为毫秒
        countdown.value = recentCreatedOrder.value.left_seconds * 1000
        startTime = Date.now()

        countdownTimer = setInterval(() => {
            const elapsed = Date.now() - startTime
            const remaining =
                recentCreatedOrder.value!.left_seconds * 1000 - elapsed

            if (remaining > 0) {
                countdown.value = remaining
            } else {
                countdown.value = 0
                if (countdownTimer) {
                    clearInterval(countdownTimer)
                    countdownTimer = null

                }
            }
        }, 100) // 每100ms更新一次，以显示毫秒
    }
}

const oneMonthPrice = (price: number) => {
    // // 不进一位，只保留两位小数（向下截断）
    // const monthPrice = Math.floor((price / 100 / 12) * 100) / 100
    // 先用整数计算避免浮点数精度问题，再除以 100
    const monthPrice = Math.round(price / 12) / 100
    return '$' + monthPrice.toFixed(2)
}

const had_close = ref(false)
const handleClose = () => {
    if (had_close.value) return
    had_close.value = true

    setTimeout(() => {
        had_close.value = false
    }, 2000)

    emitter.emit('get-pending-check-result-close')

    visible.value = false

    appStore.getRecentCreatedOrder()

    if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
    }
    if (import.meta.client) {
        localStorage.removeItem('pay_goods_id')
    }
}

const cancel_loading = ref(false)
const closePendingOrderForever = async () => {
    if (cancel_loading.value) return
    cancel_loading.value = true
    setTimeout(() => {
        cancel_loading.value = false
    }, 2000)

    emitter.emit('get-pending-check-result-close')

    // await sendCreatedOrderApi(
    //     recentCreatedOrder.value?.goods?.id,
    //     'click_cancel_pay_pending'
    // )

    handleClose()
}

// 继续支付（银行卡支付）
const handleContinuePay = () => {
    visible.value = false
    if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
    }
    const { goods, upgrade } = recentCreatedOrder.value

    // 如果是升级订阅，调用升级接口（银行卡支付使用 direct_alipay_h5
    if (upgrade) {
        emitUpgradeOrder(goods, 'direct_alipay_h5')
        return
    }

    const goods_ = { ...goods }
    if (recentCreatedOrder.value?.coupon_code) {
        goods_.coupon_code = recentCreatedOrder.value?.coupon_code
    }
    // 非升级订阅，走原来的接口
    const { subscription_type } = goods_
    const pay_type = subscription_type ? 'direct_alipay_h5' : 'direct_alipay_h5'
    emitOrderGoods(goods_, pay_type)
}

const payMoneyTypeFromPayPal = () => {
    const { goods, upgrade } = recentCreatedOrder.value

    // 如果是升级订阅，调用升级接口（PayPal 支付）
    if (upgrade) {
        // 获取 PayPal 支付类型
        const { payment_types } = goods
        const paypal_type =
            payment_types?.find((type: string) =>
                type.toLowerCase().startsWith('paypal')
            ) || 'paypal_subs_h5'

        emitUpgradeOrder(goods, paypal_type)
        visible.value = false
        if (countdownTimer) {
            clearInterval(countdownTimer)
            countdownTimer = null
        }
        return
    }

    // 非升级订阅，走原来的接口
    const { payment_types } = goods
    // 查找 payment_types 数组中是否包含以 "paypal" 开头的字符串，并返回索引位置
    const pay_type = payment_types?.find((type: string) =>
        type.toLowerCase().startsWith('paypal')
    )
    emitOrderGoods(goods, pay_type)
    visible.value = false
    if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
    }
}

const isClient = ref(false)
const loading = ref(false)
const getRecentCreatedOrder = async () => {
    if (loading.value) return
    loading.value = true
    try {
        const res: any = await getRecentCreatedOrderApi()
        if (res.status === 200) {
            recentCreatedOrder.value = res?.data || null
            if (recentCreatedOrder.value?.left_seconds) {
                startCountdown()
            }
        }
    } catch (error) {
        console.error('Failed to get recent created order:', error)
    } finally {
        loading.value = false
    }
}

watch(visible, newVal => {
    if (newVal) {
        getRecentCreatedOrder()
    }
})

// 监听订单变化，启动倒计时
watch(
    () => recentCreatedOrder.value,
    newVal => {
        if (newVal?.left_seconds) {
            startCountdown()
        } else {
            countdown.value = 0
            if (countdownTimer) {
                clearInterval(countdownTimer)
                countdownTimer = null
            }
        }
    },
    {
        immediate: true,
    }
)

// 组件挂载时启动倒计时
onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            isClient.value = true
        }
    }
})

// 组件卸载时清理定时器
onUnmounted(() => {
    if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
    }
})
</script>

<style scoped lang="less">
.percentage {
    border-radius: 4px;
    background: linear-gradient(270deg, #ff5eb7 0%, #ff8d5c 100%);
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    padding: 2px 4px;
    margin-left: 3px;
}
</style>
